// Prevent multiple declarations
if (!customElements.get("age-verification-popup")) {
    class AgeVerificationPopup extends HTMLElement {
        constructor() {
            super();

            

            // Event Listeners
            this.querySelector("#yes").addEventListener("click", () => this.closePopup());
            this.querySelector("#no").addEventListener("click", () => this.redirectToHome());
        }

        closePopup() {
            this.style.display = "none"; // Hide popup
            localStorage.setItem("ageVerified", "true"); // Store in localStorage
        }

        redirectToHome() {
            window.location.href = "/"; // Redirect on "No"
        }
    }

    // Register the custom element only if it hasn't been defined
    customElements.define("age-verification-popup", AgeVerificationPopup);
}

// Ensure it runs only on the correct template
document.addEventListener("DOMContentLoaded", () => {
    const currentTemplate = document.body.dataset.template;

    // Show only on product.age-verification-required
    if (currentTemplate === "product.age-verification-required") {
        if (!localStorage.getItem("ageVerified") && !document.querySelector("age-verification-popup")) {
            document.body.appendChild(document.createElement("age-verification-popup"));
        }
    }
});
